
(function () {
    var $ = jQuery;
    function renewSavingCardForm() {
        jQuery('.f-renewCard').validate({
            rules: {
                determination_of_user_contact_info: "required",
            },
            messages: {
                determination_of_user_contact_info: "Please confirm whether or not your contact information has changed."
            },
            errorPlacement: function (error, element) {
                error.appendTo(element.closest('.f-renewCard #edit-determination-of-user-contact-info--wrapper .fieldset-wrapper'));
            },
            errorClass: 'f-Form_Error',
            submitHandler: function () {
                const yes = document.querySelector('input#edit-determination-of-user-contact-info-contact-info-changed');
                const no = document.querySelector('input#edit-determination-of-user-contact-info-contact-info-same');
                
                if (yes.checked) {
                    window.location.href = "/savings-registration";
                } else if (no.checked) {
                    document.querySelector('div#SavingsCard_RenewalEligibilityForm').style.display = 'block';
                    jQuery('div#SavingsCard_RenewalRegistrationForm').remove();
                }
                return false;
            }
        });
    }

    function savingsCardRenewForm() {
        jQuery('.f-fastrack').validate({
            rules: {
                us_resident: {
                    "required": true,
                },
                private_insurance: {
                    "required": true,
                },
                employer_insurance: {
                    "required": true,
                },
                over_18: {
                    "required": true,
                },
                share_iqvia: {
                    "required": true,
                },
            },
            messages: {
                us_resident: "Please select a response.",
                private_insurance: "Please select a response.",
                employer_insurance: "Please select a response.",
                over_18: "Please confirm this statement is true.",
                share_iqvia: "Please confirm your consent.",
            },
            errorPlacement: function (error, element) {
                error.appendTo(element.closest("fieldset, div:has('.container-inline')"));
            },
            errorClass: 'f-Form_Error',
            submitHandler: (form, e) => {
                const isEligible =  
                document.querySelector('input[name=us_resident]:checked').value == 'YES'
                    && document.querySelector('input[name=private_insurance]:checked').value == 'YES'
                    && document.querySelector('input[name=employer_insurance]:checked').value == 'NO'
                    && document.querySelector('input[name=over_18]:checked').value == 'YES'
                    && document.querySelector('input[name=share_iqvia]:checked').value == 'YES';
                if (isEligible) {
                    document.querySelector('#SavingsCard_RenewalEligibilityForm form').submit();
                } else {
                    setTimeout(function(){ // setting timeout for GTM tagging
                        window.location.pathname = '/savings-not-eligible';
                    }, 200)
                }
            }
        });
    }

    function getUrlParam(name, url) {
        if (!url) url = location.href;
        name = name.replace(/[\[]/, "\\\[").replace(/[\]]/, "\\\]");
        var regexS = "[\\?&]" + name + "=([^&#]*)";
        var regex = new RegExp(regexS);
        var results = regex.exec(url);
        return results == null ? null : results[1];
    }

    if (document.querySelector('input[name="fast_track_reregistration_ruid"]')) {
        document.querySelector('input[name="fast_track_reregistration_ruid"]').value = getUrlParam('ruid');
    }

    if ( document.querySelector('.f-renewCard') ) {
        renewSavingCardForm();
        populateEpilepsyCookie();
    }
    
    if ( document.querySelector('.f-fastrack') ) {
        savingsCardRenewForm();
    }

    

})()